export default __webpack_public_path__ + "static/media/blog-post.2.75655ebf.md";